import { createSlice } from "@reduxjs/toolkit"

export const initialBuoyState = {
    currentConditions: [],
    allStations: [],
    form: {
        buoys: {},
        timeFrame: [],
        notes: "",
        error: "",
    },
    message: null,
    loading: false
}

export const buoySlice = createSlice({
    name: 'buoy',
    initialState: initialBuoyState,
    reducers: {
        setCurrentConditions: (state, action) => {
            state.currentConditions = action.payload;
            state.loading = false
        },
        setBuoyLoading: (state) => {
            state.loading = true
        }
    }
})

export const {
    setCurrentConditions,
    setBuoyLoading
} = buoySlice.actions;

export default buoySlice.reducer;